const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x73972F91fbFd8673Eafaab0105481A90D25E153d',
  busdAddress: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  lpAddress: '0x2A12fdCBf11CA67560Bb8b37e97112694548D1fC'
}

export default priceContracts